// extracted by mini-css-extract-plugin
module.exports = {"typeFilterContainer":"styles_typeFilterContainer__39oSn","adminTaskTypeTab":"styles_adminTaskTypeTab__1Ofv7","title":"styles_title__TaG1B"};